//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import isObject from 'lodash/isObject';
import { isCopyToClipboardSupported, copyToClipboard as _copyToClipboard } from '@/utils/vuex';
export default {
  name: 'CustomCopyClipboard',
  props: {
    content: {
      type: null,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    small: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isTruncated: false
    };
  },
  computed: {
    internalContent: function internalContent() {
      if (this.content === null || this.content === undefined) {
        return String(this.content);
      }

      var stringified = JSON.stringify(this.content, null, 2);
      return isObject(this.content) && stringified ? stringified : this.content;
    },
    isCopySupported: function isCopySupported() {
      return isCopyToClipboardSupported();
    }
  },
  mounted: function mounted() {
    this.isTruncated = this.$refs.text.offsetWidth < this.$refs.text.scrollWidth;
  },
  methods: {
    copyToClipboard: function copyToClipboard(event, copyValue) {
      event.stopPropagation();

      _copyToClipboard(copyValue);
    }
  }
};